import React from 'react';
import { Paper, Tooltip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import PropTypes from 'prop-types';

interface NoFeatureAccessProps {
  title: string;
  placeholderImage: string;
  tooltipMessage: string;
  placeholderAltText?: string;
  className?: string;
}

export default function NoFeatureAccess ({
  title,
  placeholderImage,
  tooltipMessage,
  placeholderAltText,
  className
}: NoFeatureAccessProps) {
  return (
    <div className={`no-feature-access-container ${className || ''}`}>
      <div className='no-feature-access'>
        <Paper>
          <div>
            <h3>{title}</h3>
            <img
              className='no-feature-access-placeholder'
              src={placeholderImage}
              alt={placeholderAltText || title}
            />
          </div>
        </Paper>
      </div>
      <div className='no-feature-access-icon'>
        <Tooltip title={tooltipMessage}>
          <LockIcon fontSize='inherit' />
        </Tooltip>
      </div>
    </div>
  );
}

NoFeatureAccess.propTypes = {
  title: PropTypes.string.isRequired,
  placeholderImage: PropTypes.string.isRequired,
  tooltipMessage: PropTypes.string.isRequired,
  placeholderAltText: PropTypes.string,
  className: PropTypes.string
};

NoFeatureAccess.defaultProps = {
  placeholderAltText: undefined,
  className: undefined
};
